import { useContext, useEffect, useState } from "react";
import { Context } from "./Context";
import { Modal } from "react-bootstrap";
import axios from "axios";

export default function JobStatus(props) {
  const [showModal, setShowModal] = useState()
  const [jobToEnd, setJobToEnd] = useState();
  const context = useContext(Context);

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const updateRemarks = debounce(function (remarks, job_id, job_index) {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        `/api/v1/editor-tracker-form/update-job-remarks?remarks=${remarks ? remarks : " "
        }&job_id=${job_id}`,
    }).catch((err) => {
      alert("server error");
    });
  }, 500);

  function endJob(job_id, job_index) {
    setJobToEnd({ job_id, job_index });
    setShowModal(true);
  }

  function getDateTime(ts) {
    // let utc = (new Date(ts)).toUTCString();
    // utc = utc.split(' ');
    // let time = utc[utc.length - 2];
    // time = time.split(':');
    // let am_pm = time[0] >= 12 ? 'PM' : 'AM';
    // return `${time[0] === '12' ? 12 : parseInt(time[0])%12}:${time[1]}:${time[2]} ${am_pm}`;  

    //local time
    // let local = (new Date(ts)).toLocaleString();
    let local = ts
    local = local?.toString().split('T');

    let date = local[0];
    let localtime = local[1]?.split('.');

    localtime = localtime[0]?.split(':');
    let am_pm = localtime[0] >= 12 ? 'PM' : 'AM';

    return `${date} ${localtime[0] === '12' ? 12 : parseInt(localtime[0]) % 12}:${localtime[1]}:${localtime[2]} ${am_pm}`;
  }

  let jobs = context.currDayJobs.map((jobs, idx) => (
    <tr key={idx}>
      <td>{jobs?.entp_name}</td>
      <td>{jobs?.project_name}</td>
      <td>{jobs?.project_location}</td>
      <td>{jobs?.sku_count}</td>
      <td>{jobs?.image_count}</td>
      <td>{jobs?.editing_type}</td>
      <td>{getDateTime(jobs?.job_start)}</td>
      {/* <td>{jobs.job_start}</td> */}
      <td>{jobs?.status}</td>
      <td>
        <textarea
          onChange={(event) =>
            updateRemarks(event.target.value, jobs.job_id, idx)
          }
        >
          {jobs.remarks}
        </textarea>
      </td>
      <td>
        {jobs.status === "started" ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={(event) => endJob(jobs.job_id, idx)}
          >
            &#10006;
          </div>
        ) : null}
      </td>
    </tr>
  ));

  return (
    <>
      <div className="job-status">
        <h4>Today's Job</h4>
        <table>
          <thead>
            <tr>
              <th>Enterprise</th>
              <th>Project</th>
              <th>Location</th>
              <th>SKU Count</th>
              <th>Image Count</th>
              <th>Editing Type</th>
              <th>Start Time</th>
              <th>Status</th>
              <th>Remarks</th>
              <th>End Job</th>
            </tr>
          </thead>
          <tbody>{jobs}</tbody>
        </table>
      </div>
      <EndJobModal show={showModal} onHide={() => setShowModal(false)} jobToEnd={jobToEnd} setShowModal={setShowModal} />
    </>
  );
}

function EndJobModal(props) {
  let context = useContext(Context);
  let [issuesImageCount, setIssuesImageCount] = useState({});
  let [issueId, setIssueId] = useState("");
  let [imgCount, setImgCount] = useState();

  function endJob(event) {
    event.preventDefault();
    let sku_count_done = event.currentTarget.elements.sku_count_done.value;
    let image_count_done = event.currentTarget.elements.image_count_done.value;
    axios({
      method: "post",
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        `/api/v1/editor-tracker-form/end-job?job_id=${props.jobToEnd.job_id}&sku_count_done=${sku_count_done}&image_count_done=${image_count_done}`,
      data: { issuesImageCount }
    })
      .then((res) => {
        if (res.status === 200) {
          context.setCurrDayJobs((jobs) => {
            jobs[props.jobToEnd.job_index].status = "done";
            return [...jobs];
          });
          props.setShowModal(false);
          setIssueId('');
          setImgCount(null);
        }
      })
      .catch((err) => {
        console.log('===', err)
        alert("server error");
      });
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{ padding: "10px" }} closeButton>
        <Modal.Title id="contained-modal-title-vcenter">End Job</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={endJob}>
          <div className="form-inputs">
            <input
              type="number"
              id="sku_count_done"
              placeholder="Total SKU Done"
              required
            />
            <input
              type="number"
              id="image_count_done"
              placeholder="Total Images Done"
              required
            />
          </div>
          <div className="form-inputs" style={{ marginTop: "5px" }}>
            <select
              value={issueId}
              style={{ width: "301px" }}
              onChange={(e) => {
                setImgCount(issuesImageCount[e.target.value] ?? 0);
                setIssueId(e.target.value);
              }}
            >
              <option value="">Select issues</option>
              {context.editingIssuesTypes.map((elem) => (
                <option value={elem.issue_id} key={elem.issue_id}>
                  {elem.issue_name}
                </option>
              ))}
            </select>
            <input
              type="number"
              placeholder="Image Count"
              value={imgCount}
              onChange={(e) => {
                setImgCount(e.target.value);
                if (issueId)
                  setIssuesImageCount((prev) => {
                    if (parseInt(e.target.value))
                      return { ...prev, [issueId]: e.target.value };

                    delete issuesImageCount[issueId];
                    return issuesImageCount;
                  });
              }}
            />
          </div>
          <div style={{ textAlign: "center" }} className="form-buttons">
            <button type="submit">End Job</button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}